export default __webpack_public_path__ + "static/media/client11.90e461b8.jpg";